<div class="qc-breadcrumb row {{ breadcrumbClassName }}" [ngClass]="{ 'hidden-section': !pageMetadata.breadcrumb, 'pwa-mobile-breadcrumb': isPWAMobile}">
  <div
    class="col breadcrumb-subsection"
    [ngClass]="{ 'custom-breadcrumb': this.pageMetadata.component !== null }"
  >
    <ng-template [ngIf]="this.pageMetadata.title !== ''">
      <div class="page-title d-inline">{{ this.pageMetadata.title }}</div>
    </ng-template>
    <ng-template cvDynamicContent></ng-template>
  </div>
  <div class="col-md-1 qc-breadcrumb__content-toggle" *ngIf="this.pageMetadata.subComponentShow">
    <div class="cv-tab-label">
      <div (click)="onToggleSubContentPanel()" class="qc-breadcrumb__aside-toggle">
        <i class="fas fa-list"></i>
      </div>
    </div>
  </div>
</div>

<ng-template #breadcrumbSubDetail cvDynamicContent></ng-template>
